<template>
<main class="notfound">
    <section class="notfound__card">
        <p class="notfound__code" aria-hidden="true">404</p>

        <h2 class="notfound__title">Esta página no existe</h2>

        <p class="notfound__text">
            No se ha podido encontrar lo que estás buscando. La página ya no
            existe, cambió de dirección, o tu cuenta no tiene acceso a esa sección.
        </p>

        <div class="notfound__actions">
            <button type="button" class="notfound__button" @click="goHome">
                {{ homeLabel }}
            </button>
        </div>
    </section>
</main>
</template>

<script>
import { landingRouteForPermissions, routesForPermissions } from '@/components/mixin/navigationRoutes.js'

export default {
    name: 'NotFound',
    computed: {
        // Primera sección que la sesión sí habilita. Es el único destino que se
        // puede ofrecer sin arriesgar otro rebote.
        homeRoute() {
            return landingRouteForPermissions(this.$store.getters.getPermissions) || '/inicio'
        },
        homeLabel() {
            var routes = routesForPermissions(this.$store.getters.getPermissions)
            return routes.length ? 'Ir a ' + routes[0].name : 'Ir al inicio'
        },
    },
    methods: {
        // Antes este botón hacía $router.go(-1), y por eso parecía muerto: al
        // volver atrás se cae otra vez en la ruta que rebotó hasta acá, el guard
        // la vuelve a rechazar y el usuario aterriza de nuevo en esta pantalla.
        // Un destino que la sesión sí habilita corta el ciclo.
        goHome() {
            if (this.$route.path !== this.homeRoute) {
                this.$router.push(this.homeRoute)
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.notfound {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 60vh;
    padding: 2em 1.5em;
}

.notfound__card {
    width: 100%;
    max-width: 520px;
    padding: 2.5em 2em;
    border: 1px solid var(--color-fog);
    border-radius: 8px;
    background: var(--color-white);
    text-align: center;
}

.notfound__code {
    margin: 0;
    color: var(--color-fog);
    font-size: 4.5rem;
    font-weight: 800;
    line-height: 1;
    letter-spacing: 0.04em;
}

.notfound__title {
    margin: 0.3em 0 0;
    color: var(--color-navy);
    font-size: 1.35rem;
}

.notfound__text {
    margin: 1em auto 0;
    max-width: 40ch;
    color: var(--color-graphite);
    font-size: 0.92rem;
    line-height: 1.55;
}

.notfound__actions {
    margin-top: 1.8em;
}

.notfound__button {
    padding: 0.65em 1.4em;
    border: 1px solid var(--color-navy);
    border-radius: 4px;
    background: var(--color-navy);
    color: var(--color-white);
    font-family: inherit;
    font-size: 0.88rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease;

    &:hover {
        background: var(--color-steel);
        border-color: var(--color-steel);
    }
}
</style>
